module.exports = __webpack_public_path__ + "Formulario de Inscripción (HSA).pdf";